<template>
  <div class="wrapper">
    <ul class="select-option flex">
      <li>
        <el-button
          v-if="checkPermission('业管:一键挪库', permList)"
          type="primary"
          icon="el-icon-s-promotion"
          :loading="loadingBtn"
          @click="onClickMoveCasesBtn('102501')"
        >
          一键挪库-邮件通知用户进入公示期
        </el-button>
      </li>
      <li>
        <el-button
          v-if="checkPermission('业管:一键挪库', permList)"
          type="primary"
          icon="el-icon-s-promotion"
          :loading="loadingBtn"
          @click="onClickMoveCasesBtn('102505')"
        >
          一键挪库-扣款
        </el-button>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {

  data() {
    return {
      loadingBtn: false // 按钮的加载状态
    }
  },

  computed: {
    ...mapState({
      permList: (state) => state.permission.permList
    })
  },

  created() {
    this.$emit('setCurrentMenu', '业管功能')
  },

  methods: {
    /**
     * 执行挪库操作
     */
    async onClickMoveCasesBtn(flowCode = '') {
      const _this = this

      try {
        const { data: result } = await _this.axios({
          method: 'get',
          url: `${_this.homePath()}/business-admin/move/cases/${flowCode}`
        })

        _this.$alert(result && result.message, '提示', {
          confirmButtonText: '确定'
        })
      } catch (error) {
        console.log('执行挪库操作-请求失败', error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
  display: -webkit-flex;
  align-items: center;
}

.wrapper {
  .select-title {
    font-size: 14px;
    font-weight: 700;
  }

  .select-option {
    overflow: hidden;

    li {
      float: none;
      margin: 0 10px 0 0;
    }
  }
}
</style>
